import { render, staticRenderFns } from "./UserSpecPlans.vue?vue&type=template&id=232525f6&scoped=true"
import script from "./UserSpecPlans.vue?vue&type=script&lang=js"
export * from "./UserSpecPlans.vue?vue&type=script&lang=js"
import style0 from "./UserSpecPlans.vue?vue&type=style&index=0&id=232525f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232525f6",
  null
  
)

export default component.exports